import { CustomFilter, ProductSDK } from '@b2ag/module-product-sdk'

export class CustomFilterService {
  constructor(private readonly sdk: ProductSDK) {}

  async getPartnerCustomFilters(partnerId: number): Promise<CustomFilter[]> {
    return this.sdk.getPartnerCustomFilters(partnerId)
  }

  async getDefaultFilters(): Promise<CustomFilter[]> {
    return this.sdk.getDefaultFilters()
  }
}
